import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ICurrencyPairGroupPromiseLookupService } from "../ICurrencyPairGroupPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class CurrencyPairGroupPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.CurrencyPairGroupImpl>
  implements ICurrencyPairGroupPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getPairs(groupId: Number): string[];
}
